import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Button } from '@pella/sash-framework';

const FindContractorHeader = ({ step, data, activeStep, onBtnClick, selectedContractors }) => {
	return (
		<div
			className={`pcc-step-header grid grid-cols-[auto_1fr_auto] items-center gap-x-4 border-b border-b-neutral-100 p-6 shadow-[0_2px_4px_rgba(0,0,0,0.05)] md:flex md:flex-row`}
			data-testid='find-contractor-header'
		>
			<Badge
				color='primary'
				className='col-start-1 row-span-2 row-start-1'
			>
				{data?.step}
			</Badge>
			<h3 className='col-start-2 m-0 md:flex-none'>{data?.step_heading}</h3>

			{step !== 1 && !selectedContractors && <p className='text-body-2 col-start-2 flex-12/12 text-neutral-600 md:flex-none'>Select contractors first</p>}

			{step === 1 && activeStep === 2 && (
				<div className='col-start-3 ml-auto flex items-center gap-x-4'>
					<p className='text-body-2 text-neutral-600 max-md:hidden'>{selectedContractors} Selected</p>

					<Button
						color='secondary'
						onClick={onBtnClick}
					>
						Edit
					</Button>
				</div>
			)}
		</div>
	);
};

FindContractorHeader.propTypes = {
	step: PropTypes.number,
	data: PropTypes.object.isRequired,
	activeStep: PropTypes.number,
	onBtnClick: PropTypes.func,
	selectedContractors: PropTypes.number,
};

export default FindContractorHeader;
